<template>
  <div :style="boxStyles">
    <span :style="textStyles" >{{grid_translator.letter}}</span>
  </div>
</template>

<script>
import {getCSSFromStyles} from "@/components/Common/StyleEditor/utils"
export default {
    name:"grid-translator-box",
    props:{
        grid_translator:{
            type:Object,
        },
        allow_modification:{
            type:Boolean,
            default:false
        }
    },
    components:{},
    data() {
        return{

        }
    },
    computed:{
        boxStyles(){
            return {
                ...getCSSFromStyles(this.grid_translator.styles),
                "background-image" : `url('${require('@/assets/images/grid1.png')}')`,
                "display":`flex`,
                "justify-content":`center`,
                "align-items":`center`,
                "background-repeat":"no-repeat",
                "background-size":"100% 100%"
            }
        },
        textStyles(){
            let modification_styles={}
            if(this.allow_modification){
                modification_styles={
                    "margin-left":`${this.grid_translator.modification.margin_left}px`,
                    "margin-top":`${this.grid_translator.modification.margin_top}px`
                }
                let transform_styles=[`rotate(${this.grid_translator.modification.rotate_deg}deg)`]
                if(this.grid_translator.modification.is_horizontal_flip){
                    transform_styles.push("scaleX(-1)")
                }
                if(this.grid_translator.modification.is_vertical_flip){
                    transform_styles.push("scaleY(-1)")
                }
                modification_styles["transform"]=transform_styles.join(" ")
            }
            return {
                ...getCSSFromStyles(this.grid_translator.text_styles),
                ...modification_styles,
                "font-weight":"bold",
            }
        },
    }
}
</script>

<style>

</style>